module.exports = __webpack_public_path__ + "img/7d15506.png";